import React from 'react';
export const ProductIntroSection = () => {
  const bullets = ['Más de 300 actividades físicas y cognitivas organizadas por niveles', 'Actividades para el adulto mayor y guías claras para quien acompaña', 'Bitácoras para centralizar registros y preparar mejor las consultas', 'Material educativo para complementar las indicaciones profesionales'];
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-191">
      <div className="max-w-5xl mx-auto text-center w-[92%] md:w-full" data-id="element-192">
        <div className="inline-block bg-familia-cyan text-familia-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-193">
          📚 Un sistema organizado para el acompañamiento cotidiano
        </div>
        <h2 className="text-4xl sm:text-6xl md:text-7xl font-display font-bold mb-2" data-id="element-194">
          VITALIDAD 360™
        </h2>

        <p className="text-familia-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-195">
          5 módulos centrales + 1 Módulo Maestro + 3 bonos —{' '}
          <span className="text-white font-bold" data-id="element-196">
            actividades claras para acompañar cada día.
          </span>{' '}
          <span className="text-familia-gold font-bold" data-id="element-197">
            Organización para familias, cuidadores y profesionales de habla
            hispana.
          </span>
        </p>
        <div className="bg-familia-card border border-familia-cyan/15 p-6 md:p-12 rounded-3xl mb-10 md:mb-16" data-id="element-198">
          <p className="text-familia-gray text-[15px] md:text-lg mb-8 md:mb-12 leading-relaxed" data-id="element-199">
            El Sistema Vitalidad por Niveles te ayuda a elegir una actividad
            adecuada según las posibilidades y el grado de autonomía de cada
            persona. No es un diagnóstico: adapta siempre la elección a sus
            necesidades y a las recomendaciones de sus profesionales de salud.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto" data-id="element-200">
            {bullets.map((b, i) => <div key={i} className="flex items-center gap-3" data-id="element-201">
                <span className="text-familia-green text-xl" data-id="element-202">✅</span>
                <span className="font-bold text-[15px] sm:text-base" data-id="element-203">{b}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};